import {NgModule} from '@angular/core';
import {AccordionComponent, AccordionGroupComponent} from './accordion.component';
import {CommonModule} from '@angular/common';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CommonModule],
    declarations: [AccordionComponent, AccordionGroupComponent],
    exports: [AccordionComponent, AccordionGroupComponent],
})
export class AccordionModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/accordion/accordion.module.ts